export const GetFileExtension = (file: File): string => file.name.includes(".") ? file.name.split(".").pop() ?? "" : "";